"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundAssetSettings = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var lodash_1 = require("lodash");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var mobx_react_1 = require("mobx-react");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var pages_common_1 = require("@qwilr/pages-common");
var ColorSwatch_1 = require("Common/ColorSwatch/ColorSwatch");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var inversify_react_1 = require("inversify-react");
var defaultStyles_1 = require("@CommonFrontend/Styles/BlockStyles/defaultStyles");
exports.BackgroundAssetSettings = (0, mobx_react_1.observer)(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var onChange = _a.onChange, blockStyle = _a.blockStyle, assetType = _a.assetType;
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l" },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", paddingLeft: "m", paddingRight: "m" },
            react_1.default.createElement(BackgroundAssetButton, { blockStyle: blockStyle, assetType: assetType, onClick: function () {
                    console.log("TODO: open sidebar/carousel to add ".concat(assetType));
                } }),
            react_1.default.createElement(kaleidoscope_1.Popover, { className: "nested-portal", autoStack: true, size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) {
                    var _a, _b;
                    return (react_1.default.createElement(pages_common_1.MenuItemButton, __assign({}, buttonProps, { label: "Background tint", labelSize: "s", icon: react_1.default.createElement(ColorSwatch_1.ColorSwatch, { background: (_b = (_a = blockStyle.tintColor) === null || _a === void 0 ? void 0 : _a.abs) !== null && _b !== void 0 ? _b : defaultStyles_1.defaultRgbaColor.abs, size: "large" }) })));
                } },
                react_1.default.createElement(ColorPalette_1.default, { theme: "light", onColorChange: function (color) {
                        var _a, _b, _c, _d, _e;
                        var tintColor = (0, lodash_1.merge)({}, blockStyle.tintColor, {
                            opacity: (_b = (_a = blockStyle.tintColor) === null || _a === void 0 ? void 0 : _a.opacity) !== null && _b !== void 0 ? _b : defaultStyles_1.defaultRgbaColor.opacity,
                            themeIndex: (_c = color.themeIndex) !== null && _c !== void 0 ? _c : null,
                            abs: (0, ColorUtils_1.replaceOpacity)(color.value, (_e = (_d = blockStyle.tintColor) === null || _d === void 0 ? void 0 : _d.opacity) !== null && _e !== void 0 ? _e : defaultStyles_1.defaultRgbaColor.opacity),
                        });
                        onChange("tintColor", tintColor);
                    }, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)((_b = blockStyle.tintColor) !== null && _b !== void 0 ? _b : defaultStyles_1.defaultRgbaColor), brandStore.colorsWithThemeIndex), presetColors: brandStore.colorsWithThemeIndex, includeColorPanelPicker: true, type: "block" }))),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l", paddingLeft: "l", paddingRight: "l" },
            react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Tint style", selectedValue: (_c = blockStyle.tintBlendMode) !== null && _c !== void 0 ? _c : commonTypes_1.TintBlendModeTypes.Normal, onClickHandler: function (value) {
                    onChange("tintBlendMode", value);
                }, options: [
                    {
                        label: "Normal",
                        value: commonTypes_1.TintBlendModeTypes.Normal,
                    },
                    {
                        label: "Blend",
                        value: commonTypes_1.TintBlendModeTypes.Blend,
                    },
                ] }),
            react_1.default.createElement(kaleidoscope_1.SliderInput, { label: "Tint opacity", minimum: 0, maximum: 100, initialInputValue: ((_e = (_d = blockStyle.tintColor) === null || _d === void 0 ? void 0 : _d.opacity) !== null && _e !== void 0 ? _e : defaultStyles_1.defaultRgbaColor.opacity) * 100, handleValueChange: function (value) {
                    var _a;
                    var valueAsDecimal = value / 100;
                    var colorString = ((_a = blockStyle.tintColor) === null || _a === void 0 ? void 0 : _a.abs)
                        ? (0, ColorUtils_1.replaceOpacity)(blockStyle.tintColor.abs, valueAsDecimal)
                        : "";
                    var tintColor = (0, lodash_1.merge)({}, blockStyle.tintColor, __assign({ opacity: valueAsDecimal }, (0, CommonUtils_1.includeIf)(!!colorString, { abs: colorString })));
                    onChange("tintColor", tintColor);
                } })),
        react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "m", paddingRight: "m" },
            react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "xs", paddingRight: "xs" },
                react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Background card", value: (_g = (_f = blockStyle.backgroundCard) === null || _f === void 0 ? void 0 : _f.enabled) !== null && _g !== void 0 ? _g : false, onChange: function (value) {
                        var backgroundCard = (0, lodash_1.merge)({}, blockStyle.backgroundCard, {
                            enabled: value,
                        });
                        onChange("backgroundCard", backgroundCard);
                    } })),
            react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: (_h = blockStyle.backgroundCard) === null || _h === void 0 ? void 0 : _h.enabled }, function (_a) {
                var _b, _c, _d, _e, _f;
                var expandableElementRef = _a.expandableElementRef;
                return (react_1.default.createElement("div", { ref: expandableElementRef },
                    react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", paddingTop: "xxs" },
                        react_1.default.createElement(kaleidoscope_1.Popover, { className: "nested-portal", autoStack: true, size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) {
                                var _a, _b, _c;
                                return (react_1.default.createElement(pages_common_1.MenuItemButton, __assign({}, buttonProps, { label: "Card color", labelSize: "s", icon: react_1.default.createElement(ColorSwatch_1.ColorSwatch, { background: (_c = (_b = (_a = blockStyle.backgroundCard) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.abs) !== null && _c !== void 0 ? _c : defaultStyles_1.defaultRgbaColor.abs, size: "large" }) })));
                            } },
                            react_1.default.createElement(ColorPalette_1.default, { theme: "light", onColorChange: function (color) {
                                    var _a, _b, _c, _d, _e, _f, _g;
                                    var backgroundCard = (0, lodash_1.merge)({}, blockStyle.backgroundCard, {
                                        enabled: true,
                                        color: {
                                            opacity: (_c = (_b = (_a = blockStyle.backgroundCard) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.opacity) !== null && _c !== void 0 ? _c : defaultStyles_1.defaultRgbaColor.opacity,
                                            themeIndex: (_d = color.themeIndex) !== null && _d !== void 0 ? _d : null,
                                            abs: (0, ColorUtils_1.replaceOpacity)(color.value, (_g = (_f = (_e = blockStyle.backgroundCard) === null || _e === void 0 ? void 0 : _e.color) === null || _f === void 0 ? void 0 : _f.opacity) !== null && _g !== void 0 ? _g : defaultStyles_1.defaultRgbaColor.opacity),
                                        },
                                    });
                                    onChange("backgroundCard", backgroundCard);
                                }, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)((_c = (_b = blockStyle.backgroundCard) === null || _b === void 0 ? void 0 : _b.color) !== null && _c !== void 0 ? _c : {
                                    abs: "rgba(255, 255, 255, 1)",
                                    themeIndex: null,
                                    opacity: 1,
                                }), brandStore.colorsWithThemeIndex), presetColors: brandStore.colorsWithThemeIndex, includeColorPanelPicker: true, type: "block" })),
                        react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "xs", paddingRight: "xs" },
                            react_1.default.createElement(kaleidoscope_1.SliderInput, { label: "Card opacity", minimum: 0, maximum: 100, initialInputValue: ((_f = (_e = (_d = blockStyle.backgroundCard) === null || _d === void 0 ? void 0 : _d.color) === null || _e === void 0 ? void 0 : _e.opacity) !== null && _f !== void 0 ? _f : defaultStyles_1.defaultRgbaColor.opacity) * 100, handleValueChange: function (value) {
                                    var _a, _b;
                                    var valueAsDecimal = value / 100;
                                    var colorString = ((_b = (_a = blockStyle.backgroundCard) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.abs)
                                        ? (0, ColorUtils_1.replaceOpacity)(blockStyle.backgroundCard.color.abs, valueAsDecimal)
                                        : "";
                                    var backgroundCard = (0, lodash_1.merge)({}, blockStyle.backgroundCard, {
                                        enabled: true,
                                        color: __assign({ opacity: valueAsDecimal }, (0, CommonUtils_1.includeIf)(!!colorString, { abs: colorString })),
                                    });
                                    onChange("backgroundCard", backgroundCard);
                                } })))));
            }))));
});
var BackgroundAssetButton = (0, mobx_react_1.observer)(function (_a) {
    var onClick = _a.onClick, blockStyle = _a.blockStyle, assetType = _a.assetType;
    var _b = __read((0, react_1.useState)("transparent"), 2), backgroundImageSwatch = _b[0], setBackgroundImageSwatch = _b[1];
    (0, react_1.useEffect)(function () {
        if (blockStyle.backgroundType === assetType && !!blockStyle.backgroundUrl) {
            setBackgroundImageSwatch("url(".concat(blockStyle.backgroundUrl, ")"));
        }
        else {
            setBackgroundImageSwatch("transparent");
        }
    }, [assetType, blockStyle.backgroundType, blockStyle.backgroundUrl]);
    return (react_1.default.createElement(pages_common_1.MenuItemButton, { label: assetType === "image" ? "Background image" : "Background video", labelSize: "s", icon: react_1.default.createElement(ColorSwatch_1.ColorSwatch, { background: backgroundImageSwatch, size: "large" }), onClick: onClick }));
});
